export default {
  priceMin: undefined,
  priceMax: undefined,
  priceMinCondo: undefined,
  priceMaxCondo: undefined,
  bedrooms: 0,
  bathrooms: 0,
  parkingSpaces: 0,
  usableAreasMin: undefined,
  usableAreasMax: undefined,
  amenities: [],
  stamps: [],
  hasVirtualTour: false,
  warranties: undefined,
  displayAddressType: undefined,
  constructionStatus: undefined,
}
